"use client";
import { LANGUAGE_CODES } from "@/constants/collections";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import CtaButton from "../ui/CtaButton";
import HeadingSize from "../ui/HeadingSize";
import ResponsivePicture from "../ui/ResponsivePicture";

interface TimeSectionProps {
  isPdp?: boolean;
}

export default function TimeToSection({ isPdp = false }: TimeSectionProps) {
  const { t, i18n } = useTranslation();
  return (
    <section
      className={`px-4 ${
        isPdp ? "py-4 sm:py-6 md:py-8" : "py-4 sm:py-12 md:py-16"
      } bg-white`}
    >
      {" "}
      <div className="hidden lg:block  text-center ">
        <div className="">
          <HeadingSize text={t("home.timeToSection.headingLine1")} />
          <HeadingSize text={t("home.timeToSection.headingLine2")} />
        </div>
      </div>
      <div className="">
        <div className=" grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 w-full ">
          {/* mobile - Image */}
          <div className="relative lg:hidden max-w-full">
            <ResponsivePicture
              baseSrc="/images/home/time-to"
              alt="Taking small steps"
              width={500}
              height={500}
              className="max-w-[360px] w-full mx-auto sm:rounded-xl md:rounded-2xl"
            />
          </div>

          {/* Mobile Heading */}
          <div className="lg:hidden font-['Ainslie_Sans'] font-[600] text-[#000000] text-center flex flex-col">
            <HeadingSize text={t("home.timeToSection.headingLine1")} />
            <HeadingSize text={t("home.timeToSection.headingLine2")} />
          </div>

          {/* Left side - Content */}
          <div className="space-y-4  sm:space-y-5 md:space-y-6 text-center lg:text-start px-8 lg:pl-44 ">
            <p className="text-[black] text-base sm:text-xl sm:mt-12 md:mt-32 md:text-[28px] 2xl:text-[36px] leading-relaxed lg:text-[24px] md:leading-tight lg:text-start">
              {t("home.timeToSection.description")}
            </p>
            <div>
              <Link
                aria-label="read more"
                href="https://calendly.com/ryze-expert-consultation/30min"
                data-Tes-tId="read-more-cta-home-page"
              >
                <div className="mt-4 ">
                  <button
                    id="cta-button"
                    data-test-id="cta-button"
                    aria-label={t("home.timeToSection.readMore")}
                    className="bg-[#ff0000] text-white px-6 md:px-20 py-2 text-[18px] md:text-[22px] font-normal rounded-tl-[30px] rounded-br-[30px] min-w-[180px] hover:bg-[#8f000a] transition-colors"
                  >
                    {t("home.timeToSection.readMore")}
                  </button>
                  {/* <CtaButton ctaText={t("home.timeToSection.readMore")} /> */}
                </div>
              </Link>
            </div>
          </div>

          {/* Right side - Image */}
          <div className="hidden relative lg:block overflow-hidden">
            <ResponsivePicture
              baseSrc="/images/home/time-to-web"
              alt="Taking small steps"
              width={500}
              height={500}
              className="w-full relative top-0 -right-16"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
